


export default class stickyCta {
    constructor() {
        if (document.body.offsetWidth < 769) {
            this.insertStickyCta();
        } else {
            this.removeStickyCta();
        }
    }

    insertStickyCta() {
        var body = document.body;
        if (!body.classList.contains("sticky-button-inserted")) {
            let stickyButton;
            if (window.location.href.includes("welkom-terug")) {
                stickyButton = `<div class="sticky-button-wrapper"><a href="https://www.videoland.com/abonnementen/welkom-terug" class="btn button button-red button-large"><span>Nu activeren</span></a></div>`;
            } else if (window.location.href.includes("tv-gemist")) {
                stickyButton = `<div class="sticky-button-wrapper"><a href="https://www.videoland.com/abonnementen?pakket=videoland-tvgemist" class="btn button button-red button-large"><span>Begin met terugkijken</span></a></div>`;
            } else {
                stickyButton = `<div class="sticky-button-wrapper"><a href="https://www.videoland.com/abonnementen" class="btn button button-red button-large"><span>Probeer het 14 dagen</span></a></div>`;
            }
            body.insertAdjacentHTML("afterbegin", stickyButton);
        }
        body.classList.add("sticky-button-inserted");

        this.initStickyCta();
    }

    initStickyCta() {
        const body = document.body;
        if (body) {
            if (!body.classList.contains("sticky-cta-init")) {
                this.checkCtaButtonsInView();

                document.addEventListener("scroll", () => {
                    this.checkCtaButtonsInView();
                });
            }
            body.classList.add("sticky-cta-init");
        }
    }

    checkCtaButtonsInView() {
        const ctaButtonInView = this.iterateCtaButtonsInView();

        ctaButtonInView === false ? document.body.classList.add("no-cta-in-view") : document.body.classList.remove("no-cta-in-view");
    }

    iterateCtaButtonsInView() {

        const ctaButtons = [];

        for (const button of document.querySelectorAll('.page-wrapper .btn')) {
            const buttonHref = button.getAttribute('href');
            if (buttonHref) {
                if (buttonHref.indexOf('/abonnement') != -1) {
                    ctaButtons.push(button);
                }
            }
        }

        for (const button of ctaButtons) {

            const buttonRect = button.getBoundingClientRect();

            if (
                buttonRect.top >= 1 &&
                buttonRect.left >= 1 &&
                buttonRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                buttonRect.right <= (window.innerWidth || document.documentElement.clientWidth)
            ) {
                return true;
            }
        }
        return false;
    }

    removeStickyCta() {
        if (document.body.classList.contains("sticky-button-inserted")) {
            document.body.classList.remove("sticky-button-inserted");
        }

        const stickyCta = document.querySelector('.sticky-button-wrapper');

        if (stickyCta) {
            stickyCta.remove();
        }
    }
}